import { render, staticRenderFns } from "./SetLanguage.vue?vue&type=template&id=06bec612&scoped=true&"
import script from "./SetLanguage.vue?vue&type=script&lang=js&"
export * from "./SetLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SetLanguage.vue?vue&type=style&index=0&id=06bec612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bec612",
  null
  
)

export default component.exports